var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaraLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.91 97.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 126.28,
    cy: -3061.9,
    r: 283.42,
    gradientTransform: "matrix(1.17 0 0 -1 67.38 -2906.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3c4e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45b3e7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -49.49,
    cy: -3040.84,
    r: 83.41,
    gradientTransform: "matrix(1.17 0 0 -1 67.38 -2906.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31b1e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323390"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.18 96.35c-16.18 6.81-52.5-22.07-69.28-29.6-12.15 10.52-50.64 35.65-65 29.6A8.8 8.8 0 010 93.24S59 0 71 0s70.88 93 70.88 93a7.13 7.13 0 01-3.7 3.35z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89 96.35A8.8 8.8 0 010 93.24l14.12-22 5.23-7.58a52.62 52.62 0 0114.87-3.84c10.94-.95 22.59 1.49 34.68 6.92C56.75 77.27 18.26 102.4 3.89 96.35z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.35 63.67a52.62 52.62 0 0114.87-3.84c10.94-.95 22.59 1.49 34.68 6.92-2 1.75-4.78 3.9-8 6.26-10.44-6.25-31.67-7.77-46.75-1.76z",
    opacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaraLogoIcon);
export default __webpack_public_path__ + "static/media/TaraLogoIcon.e74a38f1.svg";
export { ForwardRef as ReactComponent };